import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useFilterChangeCallback, useShowSearchMetaTooltip } from 'shared/hooks';
import { selectWorkplaceCountFilter } from 'shared/selectors/filters/workplaceCount';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

import { FILTER_KEY } from './constants';
import styles from './WorkplaceCountContainer.css';

export const WorkplaceCountContainer: FC = () => {
  const {
    label,
    value: { min, max },
  } = useSelector(selectWorkplaceCountFilter);
  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const dropdownState = useDropdown(FILTER_KEY);
  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChangeMin = useCallback(
    (gte: number | null) => {
      onChange({ action: 'setWorkplaceCount', arguments: [gte, max] });
    },
    [onChange, max],
  );

  const handleChangeMax = useCallback(
    (lte: number | null) => {
      onChange({ action: 'setWorkplaceCount', arguments: [min, lte] });
    },
    [onChange, min],
  );

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <div className={styles['range']}>
          <RangeInput
            min={1}
            max={99999}
            joined={false}
            valueMin={min}
            valueMax={max}
            onChangeMin={handleChangeMin}
            onChangeMax={handleChangeMax}
          />
        </div>
      }
    />
  );
};
